<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M23.25,23.999c-0.2,0-0.389-0.078-0.53-0.22L12,13.06L1.28,23.779c-0.142,0.142-0.33,0.22-0.53,0.22
		s-0.389-0.078-0.53-0.22c-0.292-0.292-0.292-0.768,0-1.061l10.72-10.72L0.22,1.279C0.078,1.138,0,0.949,0,0.749
		s0.078-0.389,0.22-0.53c0.141-0.142,0.33-0.22,0.53-0.22s0.389,0.078,0.53,0.22L12,10.938l10.72-10.72
		c0.142-0.142,0.33-0.22,0.53-0.22s0.389,0.078,0.53,0.22C23.922,0.36,24,0.549,24,0.749s-0.078,0.389-0.22,0.53l-10.72,10.72
		l10.72,10.72c0.292,0.292,0.292,0.768,0,1.061C23.639,23.921,23.45,23.999,23.25,23.999z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'close',
    },
    name: {
      type: String,
      required: false,
      default: 'Close',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>